<template lang="pug">
	div
		v-menu(:close-on-content-click='false' :nudge-width='300' v-model='menu' offset-x='' @update:returnValue="close")

			v-btn(slot='activator' fab='' dark='' small='' :color='colors.warning')
				v-icon(dark='') {{icon}}
			v-card
				v-layout(row wrap)
					//- v-flex.pa-1(xs2)
					//- 	v-icon( :color='colors.warning' medium) notifications
					v-flex(xs12)
						h2.text-md-center {{boxTitle}}
				v-divider
				v-list(v-if="!showAllNotifications" three-line)
					template(v-for="info in infoSession.slice(0,7)"  )
						v-list-tile(avatar='' :key="info.id")
							v-list-tile-avatar
								v-btn(icon='' ripple='')
									v-icon(v-if="!info.flag_viewed" color='info') notifications_active
									v-icon(v-if="info.flag_viewed" color='grey lighten-1') notifications
							v-list-tile-content(v-if="info.flag_notification_from_sale")
								v-list-tile-title.mx-1(v-if="!info.flag_viewed") Stock Critico Venta Terreno
								v-list-tile-title.mx-1(v-if="info.flag_viewed") Stock Critico Venta Terreno (visto)
								v-list-tile-sub-title.mx-2  {{info.created_at | mixHumanDate}}
							v-list-tile-content(v-else)
								v-list-tile-title.mx-1(v-if="!info.flag_viewed") Reporte stock 
								v-list-tile-title.mx-1(v-if="info.flag_viewed") Reporte stock (visto)
								v-list-tile-sub-title.mx-2  {{info.created_at | mixHumanDate}}
							v-list-tile-avatar
								v-btn(icon='' ripple='')
									v-icon(color='grey lighten-1' @click="showStockDetail(info.id)") info
						v-divider()
				v-list.scroll-list(v-else three-line)
					template(v-for="info in infoSession"  )
						v-list-tile(avatar='' :key="info.id")
							v-list-tile-avatar
								v-btn(icon='' ripple='')
									v-icon(v-if="!info.flag_viewed" color='info') notifications_active
									v-icon(v-if="info.flag_viewed" color='grey lighten-1') notifications
							v-list-tile-content()
								v-list-tile-title.mx-1(v-if="!info.flag_viewed") Reporte stock
								v-list-tile-title.mx-1(v-if="info.flag_viewed") Reporte stock (visto)
								v-list-tile-sub-title.mx-2  {{info.created_at | mixHumanDate}} 
							v-list-tile-avatar
								v-btn(icon='' ripple='')
									v-icon(color='grey lighten-1' @click="showStockDetail(info.id)") info
						v-divider()
				v-btn(block :color="colors.primary" dark @click='dialogAllNotificationDetail=true' v-show="showVerTodas") Ver Todas
		
		v-dialog(
			v-model="dialogDetail" 
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		)
			v-card 
				v-toolbar(dark='' color='primary')
					v-btn(icon='' dark='' @click='dialogDetail = false')
						v-icon close
					v-toolbar-title Productos bajo stock critico
				//- v-toolbar-title detalle dialog
				v-spacer
				v-card-text
					ModelDataTable(
						loading-text="Cargando productos..."
						no-data-text="Sin productos bajo stock critico."
						no-remove
						ref="table_next"
						v-bind="tableProps"
						no-actions
						no-search
					)
				//- v-toolbar-items
				//- 	v-btn(dark='' flat='' @click='dialogDetail = false') Save
		v-dialog(
			v-model="dialogAllNotificationDetail" 
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		)
			v-card 
				v-toolbar(dark='' color='primary')
					v-btn(icon='' dark='' @click='dialogAllNotificationDetail = false')
						v-icon close
					v-toolbar-title Historial Notificaciones Productos bajo stock critico
			
				v-card-text
					ModelDataTable(
						loading-text="Cargando productos..."
						no-data-text="Sin productos bajo stock critico."
						no-remove
						ref="table_next_historic"
						v-bind="tableHistoricProps"
						@detail="showDetailHistoric"
						no-search
					)
      
</template>

<script>
import datUtils from '@/mixins/reusable_mixins/DateUtils'
import headers from './services/headers'
import headersHistoric from './services/headersHistoric'
//import itemsPickerFilter from '../../Dialogs/itemsPickerFilter'
import Includes from './services/includes'
//import WhDetailProductCriticalNotifMdl from '@/models/Warehouse/WhDetailProductCriticalNotif'
import { ModelDataTable } from '@/components/reusable_components/next'
import axios from 'axios'
import filterHistoricTable from './filters'

export default {
  name: 'criticalStockBox',
  props: {
    // infoSession:{
    //   type: Object,
    //   required: false,
    // },
    boxTitle:{
      type: String,
      default: 'Reportes Stock Productos'
    },
    // image_logo:{
    //   type: String,
    //   default:require('./logos/user_male.png'),
    // },
    icon:{
      type: String ,
      default: 'notifications'
    },
    colorIconBtn:{
      type: String,
      default: 'orange',
		},
		timeInterval:{
			type: Number,
			default: 900000,
		},
		modelBox:{
			type: Function,
		},
		modelHistoricBox:{
			type: Function,
			default : null,
		}
  },
  data: function(){
    return {
			menu: false,
			infoSession:[],
			dialogDetail:false,
			headers:  headers,
			selected: null,
			showAllNotifications:false,
			idNotification:0,
			interval:null,
			dialogAllNotificationDetail:false
    }
  },
  computed: {
		tableProps(){
			if(this.idNotification === 0) return {}
			return {
						service: this.modelBox,
						headers,
						paramFilter:{wh_product_critical_notification_id:this.idNotification}
					}
		},
		tableHistoricProps(){
				return {
					service: this.modelHistoricBox,
				 headers:headersHistoric,
				 filters:filterHistoricTable,
				 //attachParams:{sort:'-created_at'},
				 
				}
		},
		showVerTodas(){
			let message = this.modelHistoricBox
			if(message === null)
			{
				return false
			}
			else{
				return true
			}
		}
	},
  methods: {
    // -- UI Modification
    // -- Data fetching
		// -- Data handling and transformations
		showStockDetail(id){
			this.dialogDetail =  true
			this.idNotification = id
		},
		/*
		 */
		fetchNotification (){
			const url = process.env.VUE_APP_API_ROUTE.concat(
        '/wh_product_critical_notification?sort=-created_at'
			)
			var ctx =this
    	axios
        .get(url)
        .then(function(response) {
					let arrData = [...response.data.data]
					ctx.infoSession = arrData
            //return response
        })
        .catch(function(error) {
            return error
        })
		},
		/*
		 */
		close(){
			this.showAllNotifications = false
			this.fetchNotification()
		},
		/*
		 */
		callNotification(){
			this.interval = setInterval(() => {
				this.fetchNotification()
    	}, this.timeInterval);
		},
		/*
		 */
		showDetailHistoric(event){
			this.showStockDetail(event.item.id)
		}	

    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
  },
  watch: {
		dialogDetail(val){
			if(!val){
				this.$refs.table_next_historic.refresh()
			}
		}
	},
  components: {
		ModelDataTable,
  },
  mixins: [datUtils],
  // filters: {},
	// -- Lifecycle Methods
	beforeMount: function(){
		this.fetchNotification()
	},
	mounted(){
		//this.$refs.table_next_historic.order.index = 3
	},
	created (){
		this.callNotification()
	},
	beforeDestroy () {
		clearInterval(this.interval)
	} 
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
	.scroll-list {
		height: 500px;
		overflow-y: auto;
	}
</style>